import { render, staticRenderFns } from "./majorPolicyStatis.vue?vue&type=template&id=7dcad7cc&scoped=true&"
import script from "./majorPolicyStatis.vue?vue&type=script&lang=js&"
export * from "./majorPolicyStatis.vue?vue&type=script&lang=js&"
import style0 from "./majorPolicyStatis.vue?vue&type=style&index=0&id=7dcad7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcad7cc",
  null
  
)

export default component.exports